<template>
  <v-flex v-if="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>

        <!-- <Spinner ref="spinner"></Spinner> -->
<div class="mb-4"><zigZag></zigZag></div>
        <v-layout text-xs-center mt-5 pb-4>
          <v-flex mb-0 xs12 mx-2>
            <v-layout justify-start row mx-3 mt-0 align-center>
              <v-flex v-if="formType!=='create'">
                <v-layout row >
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Ticket #{{ticketInfo.TicketId}}, Account #{{ticketInfo.AccountBAN}},  {{ticketInfo.Type}} </div>
                </v-layout>
              </v-flex>
              <v-flex v-if="formType=='create'">
                <v-layout row >
                  <v-icon class="mr-2">fa-plus-circle</v-icon>
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >Create New Ticket</div>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row>
                  <v-flex>
                    <v-layout class="buttons mb-0 mr-0" justify-end row>
                      <v-btn icon @click="cancel" class="pa-0 mr-0">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-flex mb-0 xs12 mx-2 v-if="formType!=='view'">
              
              <v-layout justify-start row mx-3 mt-3 align-center v-if="formType=='edit'">
                <v-icon class="mr-2">fa-plus-circle</v-icon>
                <div
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >Edit Ticket</div>
              
            </v-layout>

              <v-form v-model="valid" @submit="createTicket" ref="createTicketForm">

                    <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                      <v-layout hide-details justify-start row mt-0 mb-0>

                         <v-flex hide-details mx-4 xs3>
                       
                        <v-autocomplete
                          hide-details
                          :items="ddlAccounts"
                          v-model="ticket.AccountNumber"
                          item-text="Text"
                          item-value="Value"
                          label="Account*"
                          clearable
                          required
                          :disabled="isAccountNumberDisabled"
                          :rules="requiredRules"
                        ></v-autocomplete>
                        
                      </v-flex>

                     <v-flex mx-4 xs3>
                       
                        <v-autocomplete
                          :items="ddlTicketType"
                          v-model="ticket.TypeId"
                          item-text="Text"
                          item-value="Value"
                          label="Comment/Ticket Type*"
                          :disabled="isTypeIdDisabled"
                          :rules="requiredRules"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex mx-4 xs2>
                       
                        <v-autocomplete
                          :items="ddlTicketStatus"
                          v-model="ticket.Status"
                          item-text="Text"
                          item-value="Value"
                          label="Status*"
                          :rules="requiredRules"
                        >
                        <template slot="selection" slot-scope="data">
                      <v-layout row>
                        <v-flex
                          :class="{'green--text': data.item.Value === 'A2', 'red--text': data.item.Value === 'A1'}"
                        >{{ data.item.Text }}</v-flex>
                      </v-layout>
                    </template>
                    <template slot="item" slot-scope="data">
                      <v-layout row>
                        <v-flex
                        :class="{'green--text': data.item.Value === 'A2', 'red--text': data.item.Value === 'A1'}"
                        >{{ data.item.Text }}</v-flex>
                      </v-layout>
                    </template>
                        </v-autocomplete>
                      </v-flex>
                     
                      <v-flex mx-4 xs5> 
                        <v-text-field
                          v-model="ticket.Detail"
                          label="New Comment*"
                          :rules="requiredRules"
                          multi-line
                          rows="1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex mx-4 xs1>
                         <v-btn
                        color="success"
                        @click="createTicket"
                        class="ml-2 mr-4"
                      >
                        {{formType == "create"? "Create New" : "Add"}}
                      </v-btn>
                      </v-flex>
                      </v-layout>
                    </v-layout>

                    <!-- <v-layout hide-details justify-end row mt-0 mb-4>
                    
                    </v-layout> -->

              </v-form>

            </v-flex>
</v-flex>
        </v-layout>

    </v-card>
  </v-flex>
</template>

<script>
import Spinner from '../../components/Spinner.vue';
import axios from "axios";
import Bus from "../../bus";
import moment from 'moment';
import zigZag from '../../components/ZigZag';

export default {
  name: "CreateTicket",

  components: {
    Spinner,
    zigZag
  },

  data: () => ({
    dialog: false,
    valid: true,
    valid2: true,
    accountBAN: '',
    accountName: '',

    ddlTicketType: [],
    ddlTicketStatus:[],
    ddlAccounts:[],
 
    requiredRules: [v => !!v || "Required"],
    isAccountNumberDisabled:false,
    isTypeIdDisabled: false,
    ticket: {},
    ticketInfo:{},
    formType: null,
    
  }),

  mounted() {
    this.initialize();
  },

  methods: {
    initialize () {
      this.accountBAN = null
      this.ticket ={},
      this.ticketInfo={}
      this.isAccountNumberDisabled = false
        this.isTypeIdDisabled = false
      // this.getDropdownOptions("api/Account/GetEditAccountDdls", "ddlAccountTypes")
    },

    // Get data for elements in component from response data props
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // Get data for props of elements
    async getPropData(url, obj, prop) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`][`${prop}`] = resp.data))
        .catch(err => console.log(err));
    },

    // Get data for elements in component from response data
    async getResponseData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },

    async open(item) {
      this.dialog = true;
      // await this.getResponseData("api/Account/GetAllAccountsDDL/", "ddlAccounts")
      this.formType = "create"
      await this.getTicketsCreateDDLs()
      

      if (item.BAN !== 'all') {
        this.ticket.AccountNumber = item.BAN
        this.accountBAN = item.BAN

        this.isAccountNumberDisabled = true
        // this.populateServiceDll()
      }
    },
    async openEdit(item) {
      this.dialog = true;
      this.formType = "edit"
      await this.getTicketsCreateDDLs()
      

      if (item.BAN !== 'all') {
        this.ticket.AccountNumber = item.BAN
        this.ticket.TypeId = item.TypeId
        this.ticket.TicketId = item.TicketId
        this.ticket.Status = item.StatusId
        this.accountBAN = item.BAN
        this.isAccountNumberDisabled = true
        this.isTypeIdDisabled = true
         this.getTicketDetails(item.TicketId)
      }
    },
    

    cancel() {
      this.accountBAN = null
      this.ticket ={},
      this.ticketInfo={}
      this.isAccountNumberDisabled = false
        this.isTypeIdDisabled = false
      this.dialog = false;
      this.$emit("parentInitSelectedRow");
      // this.resetFormFilters()
    },
    close(){
      this.cancel()
      this.$root.$emit("initialize", this.initialize);
    },

    getTicketsCreateDDLs(){
      if (this.ddlTicketStatus.length < 1 && this.ddlTicketType.length < 1){
axios.get("api/Tickets/GetTicketsCreateDDLs/")
      .then(res => {
        this.ddlTicketStatus = res.data.ddlTicketStatus
        this.ddlTicketType = res.data.ddlTicketType
      })
      }
      if (this.ddlAccounts.length < 1){
        this.getResponseData("api/Account/GetAllAccountsDDL/", "ddlAccounts")
      }
    },
    getTicketDetails(TicketId){
axios.get("api/Tickets/GetTicketDetails/"+ TicketId)
      .then(res => {
        this.ticketInfo = res.data
      })
    },
    async createTicket() {
      if (this.$refs.createTicketForm.validate()) {
        let result = await this.saveTicketToDB()
        
        if (result) {
          // this.$root.$emit("initialize", this.initialize);
          var message

          if(this.formType=='create'){
        message="New Ticket Created Successfully!"
      }
      else if(this.formType='edit'){
       message="Ticket Detail Added Successfully!"
      }

          Bus.$emit("alert", {
            color: "success",
            message: message
          });
          this.close()
        }
      }
    },
    async saveTicketToDB() {
      var result
      if(this.formType=='create'){
        result = await axios.post("api/Tickets/CreateTicket", this.ticket);
      }
      else if(this.formType='edit'){
        result = await axios.post("api/Tickets/AddTicketDetail", this.ticket);
         let ticketStatusResult = await axios.post("api/Tickets/UpdateTicketStatus", this.ticket).catch(error=> {
           console.log(error)
         })
      }
      return result;
    },


    forceUpperCase(prop) {
      this.ticket[`${prop}`] = this.ticket[`${prop}`].toUpperCase()
    },

  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  },
}
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

